import { UserService } from './../../../../../../Service/UserService';
import { BasePanelController } from './../../../../../BaseUI/BasePanelController';
import { UserInfoPanelComponent } from './UserInfoPanelComponent';
import {MessageConstants} from '../../../../../../MessageConstants';
import {regExpForKana, regExpForName} from '../../../../../../Util/StringUtil';
import {PostCodeService} from '../../../../../../Service/PostCodeService';

export class UserInfoPanelController extends BasePanelController {
	public combineView: UserInfoPanelComponent;


	/**
	 * getUserInfo
	 * ユーザー情報の取得
	 * @returns ユーザー情報
	 */
	public async getUserInfo(param: { view: any }) {

		const svc = new UserService(param.view);
		const ret = await svc.getUserInfo();

		return ret;

	}

	/**
	 * editUserInfo
	 * ユーザー情報の編集
	 * @param param viewインスタンス, {ユーザー情報一覧}
	 */
	public async editUserInfo(param: { view: any; data: any; isMedEdit: boolean}) {

		const svc = new UserService(param.view);
		const ret = await svc.updateUserInfo(param.data);

		if (param.isMedEdit) {
			const retMed = await svc.saveUserMedicalInfo(param.data);
		}

		return ret;

	}

	/**
	 * 郵便番号から住所を取得
	 * @param param
	 */
	public async getAddress(param: { view: any; postCode: string }): Promise<{prefecture: string; city: string}> {

		const svc = new PostCodeService(param.view);
		return await svc.getAddress(param.postCode);

	}
	/**
	 * checkInputData
	 * 入力チェック
	 * @param formData 入力データ(共通項目)
	 */
	public checkInputData(formData: any): Array<string> {
		const msg = Array<string>();

		// 入力値チェック

		// 診察券番号（カルテ番号）
		if (formData.medicalRecord.wellnestClinic.medicalRecordNumber && !/^[0-9]{7,8}/.test(formData.medicalRecord.wellnestClinic.medicalRecordNumber)) {
			msg.push(MessageConstants.message.MESSAGE_MEDICAL_RECORD_MEDICAL_RECORD_NUMBER_NOT_MATCH_PATTERN);
		}
		// 姓
		if (!formData.lastname || formData.lastname.length < 1) {
			msg.push(MessageConstants.message.MESSAGE_USER_LASTNAME_NO_INPUT);
		}
		if (formData.lastname && !regExpForName.test(formData.lastname)) {
			msg.push(MessageConstants.message.MESSAGE_USER_LASTNAME_NOT_MATCH_PATTERN);
		}
		// 名前
		if (!formData.firstname || formData.firstname.length < 1) {
			msg.push(MessageConstants.message.MESSAGE_USER_FIRSTNAME_NO_INPUT);
		}
		if (formData.firstname && !regExpForName.test(formData.firstname)) {
			msg.push(MessageConstants.message.MESSAGE_USER_FIRSTNAME_NOT_MATCH_PATTERN);
		}
		// 姓カナ
		if (!formData.lastnameKana || formData.lastnameKana.length < 1) {
			msg.push(MessageConstants.message.MESSAGE_USER_LASTNAME_KANA_NO_INPUT);
		}
		if (formData.lastnameKana && !regExpForKana.test(formData.lastnameKana)) {
			msg.push(MessageConstants.message.MESSAGE_USER_LASTNAME_KANA_NOT_MATCH_PATTERN);
		}
		// 名前カナ
		if (!formData.firstnameKana || formData.firstnameKana.length < 1) {
			msg.push(MessageConstants.message.MESSAGE_USER_FIRSTNAME_KANA_NO_INPUT);
		}
		if (formData.firstnameKana && !regExpForKana.test(formData.firstnameKana)) {
			msg.push(MessageConstants.message.MESSAGE_USER_FIRSTNAME_KANA_NOT_MATCH_PATTERN);
		}
		// ミドルネーム
		if (formData.middlename && !regExpForName.test(formData.middlename)) {
			msg.push(MessageConstants.message.MESSAGE_USER_MIDDLENAME_NOT_MATCH_PATTERN);
		}
		// 性別
		if (!formData.gender || formData.gender.length < 1) {
			msg.push(MessageConstants.message.MESSAGE_USER_GENDER_NOT_SELECT);
		}
		// 生年月日
		if (!formData.birthday || formData.birthday.length < 1) {
			msg.push(MessageConstants.message.MESSAGE_USER_BIRTHDAY_NO_INPUT);
		}
		// 電話番号
		if (!formData.telNumber || formData.telNumber.length < 1) {
			msg.push(MessageConstants.message.MESSAGE_USER_TELL_NO_INPUT);
		}
		if (formData.telNumber && !/^[0-9]+$/.test(formData.telNumber)) {
			msg.push(MessageConstants.message.MESSAGE_USER_TELL_NOT_MATCH_PATTERN);
		}
		// 電話機種類
		if (formData.deviceType && !/^(ANDROID|IPHONE|ETC)$/.test(formData.deviceType)) {
			msg.push(MessageConstants.message.MESSAGE_USER_DEVICE_TYPE_NO_SELECT);
		}
		// 郵便番号
		// 入力があった場合、妥当性をチェックする
		if (formData.postCode !== '') {
			if (!/^[0-9]{7}$/.test(formData.postCode)) {
				msg.push(MessageConstants.message.MESSAGE_USER_POST_CODE_NOT_MATCH_PATTERN);
			}
		}
		// メールアドレス
		if (!formData.email || formData.email.length < 1) {
			msg.push(MessageConstants.message.MESSAGE_USER_EMAIL_NO_INPUT);
		}
		if (formData.email && !/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}/.test(formData.email)) {
			msg.push(MessageConstants.message.MESSAGE_USER_EMAIL_NOT_MATCH_PATTERN);
		}

		return msg;
	}
}
